export function setCachefiltersLoading (state, loading = false) {
  state.cachefiltersLoading = loading
}

export function setCachefilters (state, cachefilters) {
  if (cachefilters && cachefilters.data) {
    state.cachefilters = cachefilters.data
    state.cachefiltersCurrentPage = cachefilters.current_page
    state.cachefiltersLastPage = cachefilters.last_page
    state.cachefiltersPerPage = cachefilters.per_page
    state.cachefiltersTotal = cachefilters.total
  } else if (cachefilters && Array.isArray(cachefilters)) {
    state.cachefilters = cachefilters
    state.cachefiltersCurrentPage = 1
    state.cachefiltersLastPage = 1
    state.cachefiltersPerPage = 100
    state.cachefiltersTotal = cachefilters.length
  }
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
